// 文件i18n/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'

import LangPT from './PT'
import LangEN from './EN'
import LangZHCN from './ZH_CN'
import LangZHTW from './ZH_TW'

Vue.use(VueI18n) //会把$t挂到Vue.prototype上，以便在.vue文件中使用this.$t()

// 国际化
const i18n = new VueI18n({
    locale: localStorage.getItem('lan') || 'ZH_TW',
    messages: {
        'EN': LangEN,
        'PT': LangPT,
        'ZH_CN': LangZHCN,
        'ZH_TW': LangZHTW
    }
})

locale.i18n((key, value) => i18n.t(key, value))

export default i18n